import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { List, ListItem, ListItemText } from "@material-ui/core";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import typographyStyle from "assets/jss/material-kit-react/views/componentsSections/typographyStyle.jsx";

class SectionBody extends React.Component {
  render() {
    const { classes, data, dataCustom } = this.props;
    const dataTitle = data.map(item => item.title);
    const dataSubtitle = data.map(item => item.subtitle);
    const dataCustomAddress = dataCustom.filter((item) => item.custom_fields === 'contact_info_address').map((item) => item.value);
    const dataCustomAddressLlink = dataCustom.filter((item) => item.custom_fields === 'contact_info_address').map((item) => item.link);
    const dataCustomEmail = dataCustom.filter((item) => item.custom_fields === 'contact_info_email').map((item) => item.value);
    const dataCustomEmailLink = dataCustom.filter((item) => item.custom_fields === 'contact_info_email').map((item) => item.link);
    const dataCustomTel = dataCustom.filter((item) => item.custom_fields === 'contact_info_tel').map((item) => item.value);
    const dataCustomTelLink = dataCustom.filter((item) => item.custom_fields === 'contact_info_tel').map((item) => item.link);
    const style = {
      paddingBottom: "10px"
    }

    return (
      <div style={style} className={classes.section}>
        <div className={classes.container}>
          <div id="typography">
            <GridContainer>

              <GridItem xs={12} sm={12}>
                <div className={classes.title}>
                  <h1 className={classes.title}>{dataTitle}</h1>
                </div>
              </GridItem>

              <GridItem xs={12} sm={12}>
                <div>
                  <h2>{dataSubtitle}</h2>
                </div>
              </GridItem>

              <GridItem xs={12} sm={12}>
                  <List>
                    <ListItem>
                      <ListItemText primary="Adress" secondary={ <a href={dataCustomAddressLlink} target="_blank">{dataCustomAddress}</a> } />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="E-post" secondary={ <a href={'mailto:' + dataCustomEmailLink}>{dataCustomEmail}</a> } />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="Tel" secondary={ <a href={'tel:' + dataCustomTelLink}>{dataCustomTel}</a> } />
                    </ListItem>
                  </List>
              </GridItem>

            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(typographyStyle)(SectionBody);



// WEBPACK FOOTER //
// ./src/views/Contact/Sections/SectionBody.jsx